export default "<ng-content></ng-content>\r\n\r\n\r\n"